import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Politics from '../components/Politics.vue'
import Terms from '../components/Terms.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/politics',
    name: 'politics',
    component: Politics
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si el usuario vuelve con el botón "atrás" usa la posición guardada
    if (savedPosition) {
      return savedPosition
    } else {
      // Siempre sube al inicio en cada navegación
      return { x: 0, y: 0 }
    }
  }
})

export default router
